// Deployed frontends and /api share one origin; build-time aliases can become
// stale when a custom domain is connected or made canonical after a build.
export function resolveApiOrigin(
  browserLocation = typeof window === "undefined" ? null : window.location,
  configuredBackend = process.env.REACT_APP_BACKEND_URL,
) {
  const configured = (configuredBackend || "").trim().replace(/\/+$/, "");
  const hostname = (browserLocation?.hostname || "").toLowerCase();
  const loopback = hostname === "localhost" || hostname === "127.0.0.1"
    || hostname === "[::1]" || hostname === "::1";
  const httpOrigin = browserLocation && ["http:", "https:"].includes(browserLocation.protocol)
    ? browserLocation.origin : "";

  // Local development may serve the API on a separate port. Without a browser,
  // keep the configured base for tests and server-side tooling.
  return httpOrigin && !loopback ? httpOrigin : configured || httpOrigin || "";
}

export const API_ORIGIN = resolveApiOrigin();
